import React from 'react';

const STATUS_CLASS: Record<string, string> = {
  active: 'chip-success',
  manual_grant: 'chip-info',
  succeeded: 'chip-success',
  paid: 'chip-success',
  failed: 'chip-error',
  expired: 'chip-muted',
  revoked: 'chip-error',
  grace: 'chip-warning',
  stripe: 'chip-info',
  manual: 'chip-info',
};

export default function StatusChip({ status }: { status: string }) {
  const key = (status || '').toLowerCase();
  const cls = STATUS_CLASS[key] || 'chip-muted';
  return <span className={`admin-billing-chip ${cls}`}>{status || '—'}</span>;
}
